import Form from 'semantic-ui-react/dist/commonjs/collections/Form';
import '@purple/semantic-ui-purple-theme/components/form.css';

export default Form;
